import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '@/redux/common/baseQuery';

export interface Country {
  code: string;
  name: string;
  dial_code: string;
  priority: number;
  timezone?: string; // country-level default IANA timezone (priority countries only)
}

export interface State {
  code: string;
  name: string;
  timezone?: string; // predominant IANA timezone for auto-filling the address timezone
}

export const geoApi = createApi({
  reducerPath: 'geoApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getCountries: builder.query<{ success: boolean; data: Country[]; total: number }, void>({
      query: () => '/api/v1/geo/countries',
    }),
    getStates: builder.query<{ success: boolean; data: State[]; total: number }, string>({
      query: (countryCode) => `/api/v1/geo/states?country_code=${countryCode}`,
    }),
  }),
});

export const { useGetCountriesQuery, useGetStatesQuery } = geoApi;
